const SubmitState = {
  NotReady: 0,
  Ready: 1,
  Auto: 2
};

export default SubmitState;
